module.exports = __webpack_public_path__ + "static/media/ZCOOLXiaoWei-Regular.edea762b.ttf";